import React, { useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"

import { Alert } from "components/Alert"
import { getEventSource } from "utils/eventSourceService"
import { setProductionSchedules } from "../../store/actions/productionSchedulesAction"

const getProductionLineNames = productionLines => {
   const names = productionLines.map(line => line.name).join(", ")
   return `Production Line ${names} ${
      productionLines.length > 1 ? "are" : "is"
   } under the rescheduling process`
}

const DownTimeBar = () => {
   const dispatch = useDispatch()
   const productionSchedules = useSelector(
      state => state.productionSchedules.productionSchedules
   )
   useEffect(() => {
      const es = getEventSource()

      es.onmessage = e => {
         try {
            const data = JSON.parse(e.data)
            dispatch(setProductionSchedules(data))
         } catch (error) {
            console.error(error)
         }
      }
      es.onerror = e => console.error(e)
   }, [])

   return (
      <>
         {productionSchedules?.length > 0 ? (
            <Alert
               type="danger"
               text={getProductionLineNames(productionSchedules)}
               color="danger"
               className="m-0 p-2"
            />
         ) : null}
      </>
   )
}

export default DownTimeBar
